// extracted by mini-css-extract-plugin
export default {"icon":"JPiIzbyzj0iJmuDWiXfX","placeHolderShimmer":"Teq3RfbnBL3tTqCUUTlP"};